import React, { useState } from "react";
import "./index.css";
import { useUserInfo } from "../../../../context/user";
import { useNavigate } from "react-router-dom"; // Import navigate hook

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

const LocationModal = ({ isModalOpen, justCloseIt, data, handleSwitchAccount }) => {
  const [processing, setProcessing] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null); // Change to object

  const handleClose = () => {
    justCloseIt();
  };

  const handleAddUserSubmit = async (selectedItem) => {
    setProcessing(true);
    // Ensure selectedLocation is not null
    if (selectedItem) {
      await handleSwitchAccount(selectedItem);
    }

    setProcessing(false);
  };

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={handleClose}>
        <div className="scrollable-modal-content">
          <div style={{ position: "relative" }}>
            <p
              style={{
                position: "absolute",
                right: 0,
                width: "12px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              X
            </p>

            <p className="modalText">Locations</p>
           
              <div className="formGroup" style={{ marginBottom: "20px" }}>
                <label>Select Location</label>
                <br />
                <select
                  className="w-100"
                  style={{ width: "100%" }}
                  name="selectlocation"
                  value={selectedLocation ? selectedLocation.business_name : ""}
                  onChange={(e) => {
                    const selectedItem = data.find(item => item.business_name === e.target.value);
                    setSelectedLocation(selectedItem); // Update selected location state
                    handleAddUserSubmit(selectedItem)
                  }}
                >
                  <option value="">Select a location</option>
                  {data.length > 0 && data.map((item, index) => (
                    <option key={index} value={item.business_name}>
                      {item.business_name}
                    </option>
                  ))}
                </select>
              </div>

              
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LocationModal;
